import { Icon, Menu } from '@percent/lemonade'
import { UsersActionsMenuProps } from './UsersActionsMenu.types'

export function UsersActionsMenu({ handleSelect, items }: Readonly<UsersActionsMenuProps>) {
  return (
    <Menu title={<Icon name="menu-vertical" size={6} />} onSelect={key => handleSelect(key)} sections={[{ items }]} />
  )
}
